import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
var indexColorMap = {
  1: 'primary',
  2: 'secondary',
  3: 'terciary',
  4: 'chart4',
  5: 'chart2',
  6: 'chart3',
  7: 'chart1'
};
export var Circle = styled.div.withConfig({
  displayName: "partials__Circle",
  componentId: "sc-1ox799o-0"
})(["display:inline-block;width:", ";height:", ";border-radius:", ";", " background-color:", ";"], function (_ref) {
  var radius = _ref.radius;
  return "".concat(2 * radius, "px");
}, function (_ref2) {
  var radius = _ref2.radius;
  return "".concat(2 * radius, "px");
}, function (_ref3) {
  var radius = _ref3.radius;
  return "".concat(radius, "px");
}, function (_ref4) {
  var horizontal = _ref4.horizontal;
  return horizontal && css(["width:30px;height:6px;"]);
}, function (_ref5) {
  var theme = _ref5.theme,
    index = _ref5.index;
  return theme.colors[indexColorMap[index]];
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1ox799o-1"
})(["display:flex;position:relative;flex-flow:column;justify-content:space-between;height:auto;padding:0 14px;text-align:center;", " ", ""], getFont(-1), minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont(0)));
export var Name = styled.div.withConfig({
  displayName: "partials__Name",
  componentId: "sc-1ox799o-2"
})(["font-weight:600;", ";"], function (_ref6) {
  var isMinimal = _ref6.isMinimal;
  return isMinimal ? 'margin: auto 0;' : 'margin-bottom: auto;';
});
export var DeleteContainer = styled.div.withConfig({
  displayName: "partials__DeleteContainer",
  componentId: "sc-1ox799o-3"
})(["position:absolute;top:0;right:0;svg{width:18px;height:18px;cursor:pointer;}&:hover{color:", ";svg{stroke:", ";}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.danger;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.danger;
});